import React, { useEffect, useState } from "react";
import { FaConciergeBell } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Loading from "../../components/Loading";
import Navbar from "../../components/Navbar";
import { getTabSetting } from "../../config/config";
import { router } from "../../Constants";
import { TabBottom } from "../../Layout";
import { setKeranjang, setOrder } from "../../redux/actions/prepareActions";
import { decrypt, encrypt } from "../../utils/enkripsi";
import { formatDate } from "../../utils/formatDate";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import { socket } from "../../utils/socket";

export default function LacakPesanan() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state?.dataPrepare);
  const order = state?.order;
  let navigate = useNavigate();
  const [loadingButton, setLoadingButton] = useState(false);
  const [sidebar, setSidebar] = React.useState(false);
  let pesanan = localStorage.getItem("pesanan");
  pesanan = pesanan == null ? [] : decrypt(JSON.parse(pesanan));
  const userServer = JSON.parse(localStorage.getItem("userServer"));

  async function onLacak(items) {
    showLog("LacakPesanan Masuk onLacak");
    onCallSocketIO();
    const status = items?.["status"];
    const transId = items?.["id"] || items?.["si_id"] || items?.["trans_id"];
    if (status === "Pesanan Diproses" || status === "Selesai") {
      let saveCustomer = decrypt(
        JSON.parse(localStorage.getItem("saveCustomer"))
      );
      const tabSetting = await getTabSetting("pesan_table_qr_nonmember");
      if (tabSetting.status === "OK") {
        if (
          tabSetting.data[0].onoff === 0 &&
          (!saveCustomer || saveCustomer == "false")
        ) {
          navigate(router + "/data-diri", {
            data: items["data"],
            id: transId,
          });
        } else {
          navigate(`${router}/metode-pembayaran/${transId}`, {
            state: {
              data: items["data"],
              id: transId,
            },
          });
        }
      }
    } else {
      navigate(router + "/list-lacak-pesanan", {
        data: items,
      });
    }
    setLoadingButton(false);
    // let data = []
    // for(const item of dataPesanan){
    //     item['loading'] = false
    //     data.push(item)
    // }
    // setDataPesanan(data)
  }

  useEffect(() => {
    // loginUruzPro();
    showLog("LacakPesanan Masuk useEffect 1");
    window.addEventListener("popstate", (event) => {
      navigate(router + "/");
    });
    dispatch(setOrder());
    dispatch(setKeranjang());
  }, []);

  async function onCallSocketIO() {
    showLog("MetodePembayaran Masuk onCallSocketIO");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    const detailDataMapping = {
      "1st_process_attempt": null,
      approved_by: "",
      approved_date: "",
      billed_by: null,
      billed_date: null,
      branch_address: "",
      branch_id: "",
      branch_name: "",
      branch_npwp: "-",
      branch_picpath: "",
      branch_tel1: "",
      cashlez_callbacked: null,
      cashlez_link: "",
      cashlez_qr: "",
      charges_note: [],
      charges_value: 0,
      charges_value_non_pb1: 0,
      charges_value_pb1: 0,
      charges_value_total: 0,
      checked_by: null,
      checked_date: null,
      checked_note: null,
      client_order_id: null,
      coa_ar_customer: "",
      coa_ar_customer_name: "",
      coa_dp_so: "",
      coa_dp_so_name: "",
      coa_dp_so_tax: "",
      coa_dp_so_tax_name: "",
      code: "",
      created_by: "",
      created_by_name: "",
      created_date: "",
      customer_address: "",
      customer_id: "",
      customer_name: "",
      customer_npwp: "",
      delivery_receiver_address: "",
      delivery_receiver_id: "",
      delivery_receiver_nama: null,
      delivery_receiver_name: null,
      delivery_receiver_phone: "",
      discounts_note: [],
      discounts_value: 0,
      discounts_value_total: 0,
      dp_so: 0,
      edit_lock_by: "",
      edit_lock_by_name: "",
      estimated_pickup_time: null,
      from: "",
      grand_total: 0,
      grand_total_nett: 0,
      harga_a_note: 0,
      harga_a_note_show: "",
      hide: 0,
      id: "",
      is_billed: 0,
      is_checked: 0,
      is_prepared: 0,
      is_prepared_show: "",
      jumlah_tamu: 0,
      kembali: 0,
      kurir_id: "-",
      kurir_layanan: null,
      kurir_service: null,
      marketing_id: "",
      marketing_name: "",
      no_faktur_pajak: "",
      note: "",
      oc_id: null,
      packaging: 0,
      payment_cash_coa: "",
      payment_cash_coa_name: "",
      payment_cash_value: 0,
      payment_cc1_coa: "",
      payment_cc1_coa_name: "",
      payment_cc1_edc: "",
      payment_cc1_note: "",
      payment_cc1_value: 0,
      payment_cc2_coa: "",
      payment_cc2_coa_name: "",
      payment_cc2_edc: "",
      payment_cc2_note: "",
      payment_cc2_value: 0,
      payment_dc1_coa: "",
      payment_dc1_coa_name: "",
      payment_dc1_edc: "",
      payment_dc1_note: "",
      payment_dc1_value: 0,
      payment_dc2_coa: "",
      payment_dc2_coa_name: "",
      payment_dc2_edc: "",
      payment_dc2_note: "",
      payment_dc2_value: 0,
      payment_others_coa: "",
      payment_others_coa_name: "",
      payment_others_edc: "",
      payment_others_note: null,
      payment_others_value: 0,
      payment_total: 0,
      payment_type: 0,
      payment_type_show: "",
      picpath: "",
      platform_order_id: null,
      po_customer: "",
      posted_acc_date: null,
      posted_acc_note: null,
      posted_acc_status: 0,
      posted_inv_date: null,
      posted_inv_note: null,
      posted_inv_status: 0,
      prepared_by: null,
      prepared_by_name: "",
      prepared_date: null,
      prepared_note: null,
      print_x_times: 0,
      print_x_times_A6: 0,
      processed_by: "",
      processed_by_name: "",
      processed_date: null,
      project_id: null,
      rc_id: "",
      reservation_detail_id: null,
      room_id: null,
      so_code: "",
      so_date: "",
      so_id: "",
      sr_id: "",
      sub_total: 0,
      sync_by: null,
      sync_date: null,
      sync_trans_status: 0,
      table_id: "",
      table_reservation_id: null,
      tgl_customer_terima: null,
      tgl_keluar: null,
      therapist_id: null,
      top: 0,
      total: 0,
      total_coin_earned: 0,
      total_point_earned: 0,
      trans_date: "",
      trans_from: "",
      trans_status: 0,
      trans_status_oc: null,
      trans_status_show: "",
      updated_by: "",
      updated_by_name: "",
      updated_date: "",
      void_by: "",
      void_by_name: "",
      void_date: null,
      void_note: null,
    };
    const orderSelectedMapping = {
      accepted_rejected_at: null,
      accepted_rejected_at_show: null,
      brand_id: "",
      coa_inv: "",
      coa_sales: "",
      curr: "",
      detail_disc1: 0,
      detail_disc2: 0,
      detail_disc_value: 0,
      detail_note: "",
      expired: "",
      header: null,
      height_packing: 0,
      // id: dataBranch.detailData,
      id: "",
      indent: 0,
      kitchen_type_id: "",
      length_packing: 0,
      ln: "-",
      name: "",
      num: 0,
      num_paket: null,
      ordered_at: "",
      ordered_at_show: "",
      ordered_by: "",
      picpath1_thumb: "",
      prepared_at: "",
      prepared_at_show: "",
      prepared_by: "",
      price: 0,
      product_id: "",
      product_name: "",
      promo_name: "",
      promo_paket: 0,
      promo_price: 0,
      promo_qty: 0,
      qty: 0,
      qty_order: 0,
      qty_unit: 0,
      rate: 0,
      sn: "",
      status_save: "",
      trans_id: dataBranch.detailData,
      table_id: localStorage.getItem("meja"),
      tipe_promo: null,
      total: 0,
      unit_id: "",
      unit_id_small: "",
      use_expired: 0,
      use_ln: 0,
      use_sn: 0,
      void_at: null,
      void_at_show: null,
      void_by: null,
      void_note: null,
      void_type: 0,
      warehouse_id: "",
      warehouse_name: "",
      weight_packing: 0,
      width_packing: 0,
    };
    const dataDetailData = decrypt(
      JSON.parse(localStorage.getItem("detailData"))
    );
    const datadetailTrans = decrypt(
      JSON.parse(localStorage.getItem("detailTrans"))
    );
    const mappedDetailData = mapData(dataDetailData, detailDataMapping);
    const orderSelectedArray = order.data[0].data.map((item) => ({
      ...orderSelectedMapping,
      ...item,
      product_name: item.name || "",
    }));
    mappedDetailData.charges_note = order.data[0].chagerNote;
    mappedDetailData.charges_note = mappedDetailData.charges_note.map(
      (item) => {
        return {
          id: item.label,
          value: item.value,
        };
      }
    );
    mappedDetailData.charges_value = mappedDetailData.charges_note
      .filter((item) => item.id !== "Subtotal" && item.id !== "Total")
      .reduce((sum, item) => sum + item.value, 0);
    mappedDetailData.branch_address = dataBranch.branchAddress;
    mappedDetailData.branch_name = dataBranch.branchName;
    mappedDetailData.branch_tel1 = dataBranch.branchTel;
    mappedDetailData.picpath = dataBranch.picpath;
    mappedDetailData.picpath1_thumb = dataBranch.picpath_thumb;
    mappedDetailData.branch_npwp = dataBranch.npwpp;
    mappedDetailData.trans_date = order.data[0].date;
    mappedDetailData.delivery_receiver_name =
      localStorage.getItem("dataDiriName") || "";
    mappedDetailData.note =
      decrypt(JSON.parse(localStorage.getItem("customerNote"))) || "";
    const tableQrSocketData = {
      source: "FROM WEBSITE",
      table_id: localStorage.getItem("meja"),
      branch_id: dataBranch.branchID,
      trans_id: dataBranch.detailData,
      userServer: userServer,
      trans_date: order.data[0].date,
      detailData: mappedDetailData,
      orderSelected: orderSelectedArray,
      mode: ["kitchen", "transaction"],
      posData: {
        detailData: mappedDetailData,
        link: "",
        linkGet: "",
        orderSelected: orderSelectedArray,
        posForm: "",
        posMode: "",
        transMode: "",
      },
      jumlah_tamu: "",
      is_billed: "",
      billed_date: "",
      status: "",
      posMode: "",
      stat: 0,
    };
    sessionStorage.setItem(
      "tableQrSocketData",
      JSON.stringify(encrypt(tableQrSocketData))
    );
    if (socket?.connected) {
      showLog(`Socket Connected With ID = ${socket.id}`);
    } else {
      socket.once("connect", () =>
        showLog(`Socket Connected With ID = ${socket.id}`)
      );
    }
    let savedSiSocketData = {
      source: "FROM WEBSITE",
      billed_date: "",
      is_billed: "",
      jumlah_tamu: "",
      posMode: "",
      branch_id: dataBranch.branchID,
      table_id: localStorage.getItem("meja"),
      trans_date: order.data[0].date,
      trans_id: dataBranch.detailData,
      userServer: userServer,
    };
    sessionStorage.setItem(
      "savedSiSocketData",
      JSON.stringify(encrypt(savedSiSocketData))
    );
  }

  // async function loginUruzPro() {
  //   try {
  //     const login = await fetch('https://cool.uruz.id/auth-services/token/', {
  //       method: 'POST',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //         'Cache-Control': 'no-cache',
  //         'Accept-Encoding': 'gzip;q=1.0, compress;q=0.5',
  //       },
  //       body: JSON.stringify({
  //         email: 'syahrul05011@gmail.com',
  //         password: '12345aA-',
  //       }),
  //     });

  //     const resultLogin = await login.json();

  //     if (resultLogin && resultLogin.token) {
  //       console.log('hasil response login uruzpro', resultLogin);
  //       localStorage.setItem("tokenUruzPro", resultLogin.token);
  //       return resultLogin;
  //     } else {
  //       console.log('gagal login uruzpro', resultLogin);
  //       return;
  //     }
  //   } catch (error) {
  //     console.log('Terjadi error:', error);
  //   }
  // }

  function mapData(source, target) {
    showLog("MetodePembayaran Masuk mapData");
    const result = { ...target };
    for (const key in result) {
      if (source.hasOwnProperty(key)) {
        result[key] = source[key];
      } else {
        if (typeof result[key] === "string") result[key] = "";
        else if (Array.isArray(result[key])) result[key] = [];
        else if (result[key] === null) {
        } // no change needed
        else if (typeof result[key] === "number") result[key] = 0;
      }
    }
    return result;
  }

  return (
    <div style={{ paddingBottom: 150 }}>
      <Navbar
        label="Lacak Pesanan"
        sidebar={sidebar}
        setSidebar={(val) => setSidebar(val)}
      />
      <div style={{ backgroundColor: "#F0F0F0" }}>
        <div
          style={{
            padding: "25% 20px 20px 20px",
            display: "flex",
            margin: "0 10px 0 10px",
          }}
        >
          <FaConciergeBell color="#5451D6" size={25} />
          <div style={{ marginLeft: 20 }}>
            <div className="fonts700" style={{ fontSize: 15 }}>
              {JSON.parse(localStorage.getItem("dataBranch")).branchName}
            </div>
            <div
              className="fonts400"
              style={{ fontSize: 12, color: "#7E7E7E" }}
            >
              {JSON.parse(localStorage.getItem("dataBranch")).branchAddress}
            </div>
            <div className="fonts600" style={{ fontSize: 12 }}>
              {"ID : " +
                JSON.parse(
                  localStorage.getItem("dataBranch")
                ).detailData.substring(0, 6)}
            </div>
          </div>
        </div>
      </div>
      <div style={{ margin: "20px 10px 20px 10px" }}>
        {order?.data?.length !== 0 ? (
          <div>
            {order?.data?.map((items, index) => {
              if (
                items &&
                items["trans_status"] == 0 &&
                items["prepared_by"] != ""
              ) {
                items["status"] = "Pesanan Diproses";
              }
              if (
                items &&
                items["trans_status"] == 0 &&
                items["prepared_by"] !== ""
              ) {
                items["status"] = "Selesai";
              }
              for (var i = 0; i < items.data.length; i++) {
                let item = items.data[i];
                if (item.prepared_by) {
                  items.data[i].status = "Selesai";
                } else {
                  items.data[i].status = "Pesanan Diproses";
                }
              }
              return (
                <div
                  key={index}
                  style={{
                    margin: "30px 10px 0 10px",
                    backgroundColor: "#fff",
                    borderRadius: 5,
                  }}
                >
                  {/* <div className="fonts400">{ items['id']}</div> */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0 10px 0",
                      margin: "0px 10px 0px 10px",
                      borderBottom: "1px solid #BFBFBF",
                    }}
                  >
                    <div>
                      <div className="fonts400">Tanggal</div>
                      <Gap height={5} />

                      {items["status"] !== "Menunggu Pembayaran" && (
                        <Gap height={20} />
                      )}
                      {items["status"] !== "Menunggu Pembayaran" && (
                        <div
                          onClick={() => navigate(router + "/bill")}
                          className="fonts700"
                          style={{ color: "green", cursor: "pointer" }}
                        >
                          Lihat Bill
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: "end" }}>
                      <div className="fonts400">
                        {formatDate(items["date"])}
                      </div>
                    </div>
                  </div>
                  {items.data.map((data, index) => {
                    return (
                      <div key={index}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "10px 0 10px 0",
                            margin: "0px 10px 0px 10px",
                          }}
                        >
                          <div>
                            <div className="fonts500">
                              {data["qty"]} x{" "}
                              {(data["product_name"] || data["name"] || "")
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ")}{" "}
                            </div>
                            <div
                              className="fonts400"
                              style={{ color: "#BFBFBF" }}
                            >
                              {data["detail_note"]}
                            </div>
                          </div>
                          <div className="fonts500">
                            Rp{formatterMoney(data["price"] * data["qty"])}
                          </div>
                        </div>
                        <div
                          className="fonts400"
                          style={{
                            color:
                              data["status"] == "Pesanan Diproses"
                                ? "#FFB932"
                                : "#26D044",
                            paddingLeft: "10px",
                            marginTop: "-10px",
                          }}
                        >
                          {data["status"]}
                        </div>
                      </div>
                    );
                  })}
                  <div
                    style={{
                      borderBottom: "1px solid #BFBFBF",
                      margin: "10px 10px 0px 10px",
                    }}
                  />
                  {items?.chagerNote?.map((x, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px 0",
                        margin: x.label == "Total" ? "10px 10px" : "0px 10px",
                        borderTop:
                          x.label == "Total" ? "1px solid #BFBFBF" : "0",
                      }}
                    >
                      <span
                        className={x.label == "Total" ? "fonts700" : "fonts500"}
                        style={{ marginTop: "10px" }}
                      >
                        {x.label}
                      </span>
                      <span
                        className={x.label == "Total" ? "fonts700" : "fonts500"}
                        style={{ marginTop: "10px" }}
                      >
                        Rp{formatterMoney(x.value)}
                      </span>
                    </div>
                  ))}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 0 10px 0",
                      margin: "40px 10px 0px 10px",
                    }}
                  >
                    {(items["status"] == "Pesanan Diproses" ||
                      items["status"] == "Selesai") ? (
                      <div
                        style={{
                          width: "80%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "40px",
                        }}
                      >
                        {items["status"] == "Pesanan Diproses" ||
                          items["status"] == "Selesai" ? (
                          <Button
                            onClick={() => {
                              setLoadingButton(true);
                              navigate(router + "/order");
                            }}
                            loading={loadingButton}
                            backgroundColor="#5451D6"
                            color="#fff"
                          >
                            Tambah Pesanan
                          </Button>
                        ) : null}
                        <Button
                          onClick={() => {
                            setLoadingButton(false);
                            // let data = []
                            // for(const item of dataPesanan){
                            //     if (items['id'] == item['id']) {
                            //         item.loading = true
                            //     }
                            //     else {
                            //         item.loading = false
                            //     }
                            //     data.push(item)
                            // }

                            // setDataPesanan(data)
                            onLacak(items);
                          }}
                          loading={loadingButton}
                          backgroundColor="#5451D6"
                          color="#fff"
                        >
                          {items["status"] == "Pesanan Diproses" ||
                            items["status"] == "Selesai"
                            ? "Bayar Sekarang"
                            : "Lacak Pesanan"}
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        ) : order.loading ? (
          <Loading />
        ) : (
          <div
            style={{
              margin: "20px 10px 0 10px",
              backgroundColor: "#fff",
              borderRadius: 5,
              height: 200,
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="fonts700">Tidak ada data</span>
          </div>
        )}
      </div>
      <TabBottom />
    </div>
  );
}
